const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const REVEAL_SELECTOR = '#MainContent[data-template="index"] > .shopify-section';

/**
 * Applies one calm, once-only reveal per homepage section.
 */
class PremiumSectionMotion {
  #observer = null;

  constructor() {
    this.reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);
    this.init();
    document.addEventListener('shopify:section:load', this.onSectionLoad);
  }

  init() {
    const sections = [...document.querySelectorAll(REVEAL_SELECTOR)];
    if (!sections.length) return;

    document.documentElement.classList.add('premium-motion-ready');

    if (this.reducedMotion.matches || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('is-premium-visible'));
      return;
    }

    this.#observer ??= new IntersectionObserver(this.onIntersection, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px',
    });

    sections.forEach((section, index) => {
      section.classList.add('premium-reveal');
      if (index === 0) section.classList.add('premium-reveal--hero');

      const isInitiallyVisible = section.getBoundingClientRect().top < window.innerHeight * 0.92;
      if (isInitiallyVisible) {
        requestAnimationFrame(() => requestAnimationFrame(() => section.classList.add('is-premium-visible')));
      } else {
        this.#observer?.observe(section);
      }
    });
  }

  onIntersection = (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-premium-visible');
      this.#observer?.unobserve(entry.target);
    });
  };

  onSectionLoad = (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement) || !section.matches(REVEAL_SELECTOR)) return;
    section.classList.add('premium-reveal', 'is-premium-visible');
  };
}

new PremiumSectionMotion();
